import type { EmojiPickerAddOns } from "@circle-react-uikit/EmojiPickerV3";

export const EMOJI_RENDERER_TYPES: Record<string, EmojiPickerAddOns> = {
  emoji: "emoji",
  icon: "icons",
  shape: "shapes",
  custom: "custom",
};

export const RENDER_IMG_TYPES = ["icons", "shapes", "custom"];
